import { render, staticRenderFns } from "./DashboardUpcomingEvents.vue?vue&type=template&id=41a65324"
import script from "./DashboardUpcomingEvents.vue?vue&type=script&lang=js"
export * from "./DashboardUpcomingEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports